export const getLocalCityStructuredData = (type, data = {}) => {

  let structuredData = {
    '@context': 'https://schema.org'
  };

  const { city, state, nvalue } = data || {};
  const formattedCity = city?.split(' ').join('-');

  if (type === 'BreadcrumbList') {
    structuredData = {
      ...structuredData,
      '@type': 'BreadcrumbList',
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        item: {
          name: 'Home',
          '@id': 'https://www.homedepot.com'
        }
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          name: 'Store Locator',
          '@id': 'https://www.homedepot.com/l/store-locator'
        }
      },
      {
        '@type': 'ListItem',
        position: 3,
        item: {
          name: 'Store Directory',
          '@id': 'https://www.homedepot.com/l/storeDirectory'
        }
      },
      {
        '@type': 'ListItem',
        position: 4,
        item: {
          name: `${state}`,
          '@id': `https://www.homedepot.com/l/${state}`
        }
      }, {
        '@type': 'ListItem',
        position: 5,
        item: {
          name: `${city}`,
          '@id': `https://www.homedepot.com/l/${state}/${formattedCity}/${nvalue}`
        }
      }]
    };
  }

  return structuredData;
};
